







































































import Vue from "vue";
import { Component } from "nuxt-property-decorator";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import BaseInput from "~/components/core/BaseInput.vue";

@Component({
  name: "LoginModalComponent",
  components: { BaseInput },
})
export default class LoginModal extends Vue {
  email: string | null = null;
  password: string | null = null;
  errorMessage: string | null = null;
  emailInvalid = true;
  passwordInvalid = true;
  isLoading = false;

  get invalid() {
    return this.emailInvalid || this.passwordInvalid;
  }

  get faTimes() {
    return faTimes;
  }

  onClose() {
    if (process.browser && window) {
      window.location.hash = "";
    }
  }

  async onSubmit() {
    if (!this.email || !this.password) {
      return;
    }

    this.isLoading = true;

    this.errorMessage = await this.$store.dispatch("signIn", {
      email: this.email,
      password: this.password,
    });

    if (this.errorMessage) {
      this.isLoading = false;
      return;
    }

    this.onClose();
    await this.$router.push("/mein-vanausbau/dashboard");
    this.isLoading = false;
  }
}
